<template>
    <div class="" v-if="index_content">
        <div class="tpl-left-nav tpl-left-nav-hover" style="display: block;">
            <div class="tpl-left-nav-title">
                全域职业规划
            </div>
            <div class="tpl-left-nav-list">
                <ul class="tpl-left-nav-menu">
                    <li class="tpl-left-nav-item">
                        <router-link :to="{name: 'dashboard'}" tag="a" id="btn_desktop" class="nav-link">
                            <i class="fas fa-desktop"></i>
                            <span>工作台</span>
                        </router-link>
                    </li>
                    <div class="tpl-left-nav-split"/>
                    <li class="tpl-left-nav-item">
                        <router-link :to="{path: '/main/learning'}" tag="a" id="btn_learning" class="nav-link">
                            <i class="fab fa-leanpub"></i>
                            <span>课程学习</span>
                        </router-link>
                    </li>
                    <li class="tpl-left-nav-item" @click="set_display_posts_params('weblogs')">
                        <router-link :to="{path: '/main/mylog'}" tag="a" id="btn_mylog" class="nav-link">
                            <i class="fa fa-route"></i>
                            <span>成长记忆</span>
                        </router-link>
                    </li>
                    <li class="tpl-left-nav-item" @click="set_display_posts_params('moments')">
                        <router-link :to="{path: '/main/moments'}" tag="a" id="btn_moments" class="nav-link">
                            <i class="fa fa-spa"></i>
                            <span>快乐生活</span>
                        </router-link>
                    </li>
                    <li class="tpl-left-nav-item" @click="set_display_posts_params('management')">
                        <router-link :to="{path: '/main/management'}" tag="a" id="btn_management" class="nav-link">
                            <i class="fa fa-newspaper-o"></i>
                            <span>管理论坛</span>
                        </router-link>
                    </li>
                    <div class="tpl-left-nav-split"/>
                    <!--<li class="tpl-left-nav-item">-->
                    <!--<router-link :to="{path: '/main/library'}" tag="a" id="btn_library" class="nav-link">-->
                    <!--<i class="fa fa-database"></i>-->
                    <!--<span>知识库</span>-->
                    <!--</router-link>-->
                    <!--</li>-->
                    <!--<li class="tpl-left-nav-item">-->
                        <!--<router-link :to="{path: '/main/apps'}" tag="a" id="btn_apps" class="nav-link">-->
                            <!--<i class="fa fa-th"></i>-->
                            <!--<span>应用</span>-->
                        <!--</router-link>-->
                    <!--</li>-->
                    <li class="tpl-left-nav-item">
                        <router-link :to="{path: '/main/groups'}" tag="a" id="btn_groups" class="nav-link">
                            <i class="fab fa-galactic-republic"></i>
                            <span>圈子</span>
                        </router-link>
                    </li>
                    <li class="tpl-left-nav-item">
                        <router-link :to="{path: '/main/discuss'}" tag="a" id="btn_discuss" class="nav-link">
                            <i class="fab fa-discourse"></i>
                            <span>讨论</span>
                        </router-link>
                    </li>
                    <li class="tpl-left-nav-item">
                        <router-link :to="{path: '/main/follow'}" tag="a" id="btn_follow" class="nav-link">
                            <i class="fa fa-heart-o"></i>
                            <span>关注</span>
                        </router-link>
                    </li>
                    <li class="tpl-left-nav-item">
                        <router-link :to="{path: '/main/collect'}" tag="a" id="btn_collect" class="nav-link">
                            <i class="fa fa-star"></i>
                            <span>收藏</span>
                        </router-link>
                    </li>
                    <div class="tpl-left-nav-split"/>
                    <li class="tpl-left-nav-item">
                        <router-link :to="{path: '/main/recycle'}" tag="a" id="btn_recycle" class="nav-link">
                            <i class="fa fa-trash-alt"></i>
                            <span>回收站</span>
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    import {mapState, mapActions,mapGetters} from 'vuex'

    export default {
        data: function () {
            return {
                show_sub_header: -1
            }
        },
        computed: {
            ...mapState({
                index_content: state => state.library.index_content
            }),
            ...mapGetters({
                weblogs_post_column: 'post/weblogs_post_column',
                moments_post_column: 'post/moments_post_column'
            }),
        },
        methods: {
            ...mapActions({
                change_display_posts_params: 'post/change_display_posts_params',
                change_active_column_id: 'post/change_active_column_id',
            }),
            enter_sub_header: function (index) {
                this.show_sub_header = index
            },
            out_sub_header: function () {
                this.show_sub_header = -1
            },
            set_display_posts_params: function (type) {
                this.change_display_posts_params({
                    'column_id': 0,
                    'type': type,
                })
                if (type=='weblogs' && this.weblogs_post_column){
                    this.change_active_column_id(this.weblogs_post_column[0].id)
                }
                else if (type=='moments' && this.moments_post_column){
                     this.change_active_column_id(this.moments_post_column[0].id)
                }
                else if (type=='management' && this.moments_post_column){
                     this.change_active_column_id(this.moments_post_column[0].id)
                }
            }
        }
    }
</script>
<style type="text/css" scoped>


</style>
